import { SvgIconBase } from '../utils/types';

export default function CTAArrow({
  width = '23',
  height = '14',
  className = 'fill-current',
}: SvgIconBase) {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 23 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Group 1597883410">
        <path
          id="Vector"
          opacity="0.4"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.2666 6.99746C15.2666 7.7107 14.727 8.28886 14.0613 8.28886H2.00819C1.3425 8.28886 0.802879 7.7107 0.802879 6.99746C0.802879 6.28422 1.3425 5.70605 2.00819 5.70605H14.0613C14.727 5.70605 15.2666 6.28422 15.2666 6.99746Z"
          fill="currentColor"
        />
        <path
          id="Vector_2"
          d="M21.5208 8.58212C21.8739 8.18604 22.1973 7.67646 22.1973 6.99886C22.1973 6.32126 21.8739 5.81412 21.5208 5.41818C21.192 5.04935 20.6746 4.61273 20.1482 4.16851L18.9262 3.13713C18.0313 2.38171 17.2822 1.74936 16.6587 1.36179C16.0316 0.971953 15.2606 0.655223 14.4612 1.03444C13.64 1.42401 13.3723 2.26615 13.2636 3.02393C13.1573 3.7653 13.1573 4.75943 13.1574 5.9328V8.06749C13.1573 9.24086 13.1573 10.235 13.2636 10.9764C13.3723 11.7342 13.64 12.5763 14.4612 12.9658C15.2606 13.3451 16.0316 13.0283 16.6587 12.6385C17.2822 12.2509 18.0313 11.6186 18.9263 10.8631L20.1482 9.83181C20.6746 9.38757 21.192 8.95094 21.5208 8.58212Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}
